import { paramTypeValueSchema } from "../../schemas/paramDefSchema.js";
import { paramTypeNameSchema } from "../../schemas/paramTypeSchema.js";
// type guard per ParamTypeValue
export function isParamTypeValue(value) {
    return paramTypeValueSchema.safeParse(value).success;
}
// type guard per ParamTypeName
export function isParamTypeName(value) {
    return paramTypeNameSchema.safeParse(value).success;
}
//# sourceMappingURL=type-guards.js.map